import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";
import config from "./config";

export type GetTranslationsResponse = {
  translations: Record<string, string>;
  languages: any;
};

const useTranslationQuery = (language: string) =>
  useQuery({
    queryKey: ["translations", language],
    queryFn: async () => {
      const auth = Cookies.get("auth-token");

      const url = new URL(`${config.TRANSLATIONS_BASE_URL}/i18n/${language}`);
      url.searchParams.append("system", config.I18N_SYSTEM);

      const response = await fetch(url, {
        credentials: "include",
        headers: {
          authorization: auth ?? "",
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch translations`);
      }

      return response.json() as Promise<GetTranslationsResponse>;
    },
    // We need to do this because we don't want to refetch the translations every time we change the language
    staleTime: Infinity,
  });

export default useTranslationQuery;
